import React from 'react';
import Fab from '@mui/material/Fab';
import Zoom from "@mui/material/Zoom";
import {useTranslation} from "react-i18next";
import {Edit} from "@mui/icons-material";

interface MuiFabButtonAddProps {
    onClick: () => void;
    label?: string;
    isDisabled?: boolean
}

const MuiFabButtonEdit: React.FC<MuiFabButtonAddProps> = ({onClick, label, isDisabled = false}) => {
    const {t} = useTranslation()

    return (
        <Zoom in={true} unmountOnExit>
            <Fab color="primary" aria-label="add" onClick={onClick} variant="extended" disabled={isDisabled}>
                <Edit style={{color: 'white'}}/>
                {label && (
                    <span style={{textTransform: 'uppercase', color: 'white', marginLeft: '8px'}}>
                        {t(label)}
                    </span>
                )}
            </Fab>
        </Zoom>
    );
};

export default MuiFabButtonEdit;
